import { Component, Input } from '@angular/core';
import { Location } from 'src/app/_models/daws/trip';

@Component({
  selector: 'route-dialog-location',
  templateUrl: './route-dialog-location.component.html',
})
export class RouteDialogLocationComponent {
  @Input() location: Location;
}
